var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlmLogo = function SvgXlmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-textPrimary, #000000)",
    d: "m19.797 5.542-2.401 1.224-11.598 5.907q-.06-.449-.059-.902a6.91 6.91 0 0 1 10.278-6.023l1.374-.7.206-.105a8.439 8.439 0 0 0-13.372 7.473 1.535 1.535 0 0 1-.834 1.483l-.724.37v1.724L4.8 14.905l.69-.352.682-.347 12.226-6.23 1.374-.7 2.84-1.447V4.106zM22.613 7.555 6.867 15.572l-1.373.7-2.827 1.441v1.723l2.807-1.43 2.402-1.224 11.61-5.916q.058.452.058.908a6.91 6.91 0 0 1-10.288 6.022l-.084.045-1.49.76a8.439 8.439 0 0 0 13.372-7.475 1.54 1.54 0 0 1 .833-1.484l.726-.37z"
  })));
};
export default SvgXlmLogo;